import React from 'react';
import { Checkbox as MuiCheckbox } from '@mui/material';
import { Icons } from '../Icons/Icons';
import './Checkbox.scss';

interface CheckboxProps {
  checked?: boolean;
  indeterminate?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const Checkbox: React.FC<CheckboxProps> = ({ checked, indeterminate, onChange }) => {
  return (
    <MuiCheckbox
      checked={checked}
      indeterminate={indeterminate}
      onChange={onChange}
      color="primary"
      icon={Icons.Checkbox}
      checkedIcon={Icons.CheckboxChecked}
      indeterminateIcon={Icons.CheckboxMinus}
      className="checkbox"
    />
  );
};
